import { friendInviteFeedback } from "../Helpers/friendInviteFeedback";
import OMT_UI_SquareButton, { BUTTONCOLOURS } from '../../OMT_UI/OMT_UI_SquareButton';

(function() {

var PositionName = {
  Hidden:  'hidden',
  Visible: 'visible'
};

G.HighscorePanelIngame = function() {
  Phaser.Group.call(this, game);
  this.fixedToCamera = true;

  var contentBg = G.makeImage(0,0,"leaderboard_ingame_panel",[0.5,1],this);
  contentBg.inputEnabled = true;
  contentBg.events.onInputDown.add(function() {
    this._clicked = true;
  }, this);
  this._clicked = false;

  var contentGroup = this.add(game.add.group());
  contentGroup.x = -302;
  contentGroup.y = -85;

  this._currentLeaderboard = new G.HighscorePanelLeaderboard({
    entriesNr: 5,
    allEntries: true,
    displayPos: true
  });
  this._leaderboardCachedWidth = this._currentLeaderboard.width;
  contentGroup.add(this._currentLeaderboard);
  this.add(contentGroup);

  this._maskWidth = 604;
  this._maskHeight = 80;
  var maskGfx = this.add(game.add.graphics());
  maskGfx.y = -85;
  maskGfx.alpha = 0.5;
  maskGfx.beginFill(0xff0000,1);
  maskGfx.drawRect(this._maskWidth*-0.5,0,this._maskWidth-140,this._maskHeight);

  this._currentLeaderboard.mask = maskGfx;

  const clickFunction = async () => {
    let result = await OMT.social.chooseContextAndInvite();
    if (result) {
      let feedback = new friendInviteFeedback(G.game, null);
      feedback.x = game.world.bounds.x + game.width/2;
      feedback.y = feedback.height/2;
      game.world.addChild(feedback);

      feedback.enterAndSelfDestroy();
    }
  };
  const inviteBtn = new OMT_UI_SquareButton(235, -45, {
    button: {
      tint: BUTTONCOLOURS.orange,
      dimensions: {
        width: 132,
        height: 68,
      },
      extraDetail: false,
    },
    text: {
      string: OMT.language.getText("Invite!"),
      textStyle: {
        style: 'font-white',
        fontSize: 50,
      },
    },
    options: {
      clickFunction: {
        onClick: clickFunction.bind(this),
      },
    },
  });
  this.add(inviteBtn);

  this._mover = createMover(0.1);
  this._mover.addPosition(PositionName.Hidden, 200);
  this._mover.addPosition(PositionName.Visible, 0);
  this._mover.signals.targetReached.add(function(positionName) {
    if (positionName === PositionName.Hidden) {
      this.visible = false;
      this.exists = false;
    }
  }, this);
  this._mover.signals.targetPositionChanged.add(function(positionName) {
    if (positionName === PositionName.Visible) {
      this.visible = true;
      this.exists = true;
    }
  }, this);
  this._mover.setCurrentPosition(PositionName.Hidden);

  this._inputInfo = {
    prevX: null,
    prevY: null,
    velX: 0,
    velY: 0
  };

  this.update();

  // fix for bug of showing the wrong scene state
  this._sceneStateChanged = false;
  game.state.onStateChange.addOnce((state) => {
    this.makeHidden();
    this._sceneStateChanged = true;
    this.visible = false;;
  });
}

G.HighscorePanelIngame.prototype = Object.create(Phaser.Group.prototype);

G.HighscorePanelIngame.prototype.removeCurrentLeaderboardData = function() {
  this._currentLeaderboard.removeData();
};

G.HighscorePanelIngame.prototype.makeVisible = function() {
  if (this._sceneStateChanged) return // dont allow if the scene state has changed
  this._mover.setTargetPosition(PositionName.Visible);
};

G.HighscorePanelIngame.prototype.makeHidden = function() {
  if (this._sceneStateChanged) return // dont allow if the scene state has changed
  this._mover.setTargetPosition(PositionName.Hidden);
};

G.HighscorePanelIngame.prototype.injectLevelData = function(data, beatenFriendData) {
  this._currentLeaderboard.init(data);
  this._leaderboardCachedWidth = this._currentLeaderboard.width;
  this._currentLeaderboard.centerOnCurrent(this._maskWidth, this._maskHeight);
};

G.HighscorePanelIngame.prototype.update = function() {
  this.cameraOffset.x = game.width * 0.5;
  this.cameraOffset.y = game.height + this._mover.getCurrentValue();
  this._currentLeaderboard.update();
  this._updateInput();

  this._mover.update();
};

G.HighscorePanelIngame.prototype._updateInput = function() {

  if (
    this._clicked                      &&
    this._currentLeaderboard           &&
    this._currentLeaderboard.hasData() &&
    game.input.activePointer.isDown
  ) {

    if (this._inputInfo.prevX !== null) {
      this._inputInfo.velX = 0.5 * (game.input.activePointer.x - this._inputInfo.prevX);
    }

    if (this._inputInfo.prevY !== null) {
      this._inputInfo.velY = 0.5 * (game.input.activePointer.y - this._inputInfo.prevY);
    }

    if (!this.scrolled) {
      this.scrolled = true;
    }

    this._inputInfo.prevX = game.input.activePointer.x;
    this._inputInfo.prevY = game.input.activePointer.y;

  } else {
    this._clicked = false;
    this._inputInfo.prevY = null;
    this._inputInfo.prevX = null;
  }

  if (this._currentLeaderboard) {
    this._currentLeaderboard.x += this._inputInfo.velX;
    this._boundRistrict(this._currentLeaderboard);
  }

  this._inputInfo.velX *= 0.95;
  this._inputInfo.velY *= 0.95;

  if (Math.abs(this._inputInfo.velX) < 1) this._inputInfo.velX = 0;
  if (Math.abs(this._inputInfo.velY) < 1) this._inputInfo.velY = 0;

};

G.HighscorePanelIngame.prototype._boundRistrict = function(leaderboard) {
  var maxX = 0;
  var minX = Math.min(0, -(this._leaderboardCachedWidth - this._maskWidth)) - 140;

  if (leaderboard.x > maxX) {
    leaderboard.x = G.lerp(leaderboard.x, maxX, 0.5);
    if (leaderboard.x < maxX + 1) leaderboard.x = maxX;
  }

  if (leaderboard.x < minX) {
    leaderboard.x = G.lerp(leaderboard.x, minX, 0.5);
    if (leaderboard.x > minX+1) leaderboard.x = minX;
  }
};

//

function createMover(factor) {

  var THRESHOLD = 1;

  var valueByPositionName = {};

  var currentValue = 0;
  var targetPositionName;

  var signals = {
    targetPositionChanged: new Phaser.Signal(),
    targetReached:         new Phaser.Signal()
  };

  return {
    signals: signals,

    addPosition:         addPosition,
    setCurrentPosition:  setCurrentPosition,
    getCurrentValue:     getCurrentValue,
    setTargetPosition:   setTargetPosition,
    update:              update
  };

  function addPosition(positionName, value) {
    valueByPositionName[positionName] = value;
  }

  function setCurrentPosition(positionName) {
    targetPositionName = positionName;
    currentValue = getTargetValue();
    checkTargetReached();
  }

  function setTargetPosition(positionName) {
    if (targetPositionName !== positionName) {
      targetPositionName = positionName;
      signals.targetPositionChanged.dispatch(targetPositionName);
      checkTargetReached();
    }
  }

  function getCurrentValue() {
    return currentValue;
  }

  function update() {
    var targetWasReached = isTargetReached();
    currentValue = G.lerp(currentValue, getTargetValue(), factor);
    if (!targetWasReached) checkTargetReached();
  }

  function getTargetValue() {
    return valueByPositionName[targetPositionName];
  }

  function getDistanceToGoal() {
    return Math.abs(getTargetValue() - currentValue);
  }

  function isTargetReached() {
    return getDistanceToGoal() < THRESHOLD;
  }

  function checkTargetReached() {
    if (isTargetReached()) signals.targetReached.dispatch(targetPositionName);
  }
}

}());
